module.exports = __webpack_public_path__ + "img/service_bankbook.ee057aaf.svg";